export const styleSelect = {
    indicatorSeparator: ()=>({
      opacity: 0
    }),
    placeholder: ()=>({
      fontSize: 13,
      fontFamily: 'Gilroy, sans-serif',
      fontWeight: 400,
      lineHeight: '23.5px',
      textAlign: 'left',
      color: '#636363',
      border: 'none'
    }),
    input:()=> ({
      opacity: 0,
      position: 'absolute',
      cursor: 'pointer',
      zIndex:-1
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderRadius: 50,
      height: 52.8,
      padding: '0px 20px',
      border: !state.isFocused ? 'solid #e3e3e3 2px' : '1px solid #72C5FF',
      outline : 'none' 
    }),
  };
  
  export const styleSelectWithValue = {
    indicatorSeparator: ()=>({
      opacity: 0
    }),
    placeholder: ()=>({
      fontSize: 13,
      fontFamily: 'Gilroy, sans-serif',
      fontWeight: 400,
      lineHeight: '23.5px',
      textAlign: 'left',
      color: '#636363',
      border: 'none'
    }),
    input:()=> ({
      opacity: 0,
      position: 'absolute',
      cursor: 'pointer',
      zIndex:-1,
    }),
    dropdownIndicator:()=> ({
      color: '#72C5FF',
    }),
    singleValue:()=> ({
      color: '#72C5FF',
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderRadius: 50,
      height: 52.8,
      padding: '0px 20px',
      border: '2px solid #72C5FF',
      color: '#72C5FF',
      outline : 'none' 
    }),
  }